import React, { JSX } from 'react';
import Style from './StatusLegend.module.scss';

const StatusLegend: React.FC = (): JSX.Element | null => {
  return (
    <div className={Style.legend}>
      <h3 className={Style.heading}>ステータス表示の見方</h3>
      <div className={Style.items}>
        <dl className={Style.item} data-status="normal">
          <dt className={Style.label}>メンテナンス・障害なし</dt>
          <dd className={Style.caption}>障害未発生かつ、直近12時間以内にメンテナンス予定がない場合に表示されます。</dd>
        </dl>
        <dl className={Style.item} data-status="trouble">
          <dt className={Style.label}>一部 障害発生中</dt>
          <dd className={Style.caption}>サービスの一部で障害が発生している場合に表示されます。</dd>
        </dl>
        <dl className={Style.item} data-status="maint">
          <dt className={Style.label}>一部 メンテナンス予定あり</dt>
          <dd className={Style.caption}>障害未発生かつ、直近12時間以内にメンテナンス予定がある場合に表示されます。</dd>
        </dl>
      </div>
    </div>
  );
};

export default StatusLegend;
